import { addCalendarDays, calendarDayKey, startOfLocalDay } from '../../../services/dateUtils';

export const EVENTS_MAP_WHEN = Object.freeze(['today', 'week', 'month', 'all']);

/** Upcoming horizon when the aggregate has no future day. */
export const EVENTS_MAP_ALL_FALLBACK_DAYS = 180;

export function normalizeEventsMapWhen(value) {
  return EVENTS_MAP_WHEN.includes(value) ? value : 'today';
}

/** List unless the lab is on and the URL asks for the map. */
export function resolveEventsPageView(experimentOn, searchParams) {
  if (!experimentOn) return 'list';
  const view = typeof searchParams?.get === 'function' ? searchParams.get('view') : '';
  return view === 'map' ? 'map' : 'list';
}

function endOfIsoWeekExclusive(today) {
  const day = today.getDay();
  if (day === 0) return addCalendarDays(today, 1);
  return addCalendarDays(today, 8 - day);
}

function allRangeEnd(start, byDay) {
  const startKey = calendarDayKey(start);
  let maxKey = '';
  if (byDay && typeof byDay === 'object') {
    Object.keys(byDay).forEach((key) => {
      if (/^\d{4}-\d{2}-\d{2}$/.test(key) && key >= startKey && key > maxKey) maxKey = key;
    });
  }
  if (!maxKey) return addCalendarDays(start, EVENTS_MAP_ALL_FALLBACK_DAYS);
  const [year, month, day] = maxKey.split('-').map(Number);
  return addCalendarDays(new Date(year, month - 1, day), 1);
}

/**
 * Inclusive start, exclusive end, both local midnights. Every range starts today.
 * @param {string} when
 * @param {Date} [now]
 * @param {Record<string, number>|null} [byDay] aggregate days for "all"
 */
export function eventsMapRangeBounds(when, now = new Date(), byDay = null) {
  const start = startOfLocalDay(now);
  const key = normalizeEventsMapWhen(when);
  if (key === 'week') return { start, end: endOfIsoWeekExclusive(start) };
  if (key === 'month') return { start, end: new Date(start.getFullYear(), start.getMonth() + 1, 1) };
  if (key === 'all') return { start, end: allRangeEnd(start, byDay) };
  return { start, end: addCalendarDays(start, 1) };
}
